<template>
  <VersionSelect v-if="plp_task_id" fluid>
    <template #content="{ data, readonly, onChange, onBlur, onCreate }">
      <ExpertiseTabsList
        :value="data"
        :readonly="readonly"
        :onCreate="onCreate"
        :dictType="dict"
        @change="onChange"
        @blur="onBlur"
      />
    </template>
  </VersionSelect>
</template>

<script>
import VersionSelect from '@/components/VersionSelect'
import ExpertiseTabsList from '@/components/expAvbKei/ExpertiseTabsList'
import { mapGetters } from 'vuex'

export default {
  components: {
    VersionSelect,
    ExpertiseTabsList,
  },
  data: () => ({
    dict: 'kei',
  }),
  computed: {
    ...mapGetters(['plp_task_id']),
  },
}
</script>
